// swiper v6（webpack 4 互換版）: モジュールは 'swiper' 本体から import して use() で登録する
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay])

class Slider {
  initialize() {
    const mainSliderContainer = document.querySelector('.js-slider')
    if (mainSliderContainer) {
      const mainSlider = mainSliderContainer.querySelector('.swiper')
      if (!mainSlider) return

      const slideCount = mainSlider.querySelectorAll('.swiper-slide').length
      new Swiper(mainSlider, {
        slidesPerView: 1.2,
        spaceBetween: 5,
        centeredSlides: true,
        loop: false,
        loopAdditionalSlides: 3,
        autoplay: slideCount > 1 ? {
          delay: 4000,
          disableOnInteraction: false,
        } : false,
        pagination: {
          el: mainSliderContainer.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: mainSliderContainer.querySelector('.swiper-button-next'),
          prevEl: mainSliderContainer.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: false,
          },
        },
      })
    }

    // メンバーカルーセル
    const memberSlider = document.querySelector('.js-member-slider')
    if (memberSlider) {
      new Swiper(memberSlider, {
        centeredSlides: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 0,
      })
    }

    const liveSliderContainer = document.querySelector('.js-firstlive-slider')
    if (liveSliderContainer) {
      const liveSlider = liveSliderContainer.querySelector('.swiper')
      if (!liveSlider) return

      const liveSlideCount = liveSlider.querySelectorAll('.swiper-slide').length
      new Swiper(liveSlider, {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: liveSlideCount > 3,
        loopAdditionalSlides: 3,
        navigation: {
          nextEl: liveSliderContainer.querySelector('.swiper-button-next'),
          prevEl: liveSliderContainer.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: liveSliderContainer.querySelector('.swiper-pagination'),
          clickable: true,
        },
      })
    }
  }
}
export default new Slider()
